import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

export const DocumentWithCredits: React.FC = () => {
  const [creditsOffset, setCreditsOffset] = useState(0);

  // Rolling credits animation
  useEffect(() => {
    const interval = setInterval(() => {
      setCreditsOffset(prev => prev - 1); // Continuous scroll
    }, 50); // Smooth rolling

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-[300px] h-[360px] relative">
      <svg
        viewBox="0 0 300 360"
        className="w-full h-full"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          {/* Gradients */}
          <linearGradient id="docGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#f8fafc" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#e2e8f0" stopOpacity="0.95" />
          </linearGradient>
          
          {/* Document mask for rolling credits */}
          <clipPath id="docClip">
            <rect x="50" y="50" width="200" height="260" rx="8" />
          </clipPath>
        </defs>

        {/* Abstract Document Container */}
        <motion.g
          animate={{ 
            scale: [1, 1.01, 1],
            opacity: [0.9, 1, 0.9]
          }}
          transition={{
            duration: 4,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        >
          {/* Document shadow */}
          <rect
            x="54"
            y="54"
            width="200"
            height="260"
            rx="8"
            fill="rgba(0,0,0,0.1)"
          />
          
          {/* Main document */}
          <rect
            x="50"
            y="50"
            width="200"
            height="260"
            rx="8"
            fill="url(#docGradient)"
            stroke="#cbd5e1"
            strokeWidth="2"
          />
        </motion.g>

        {/* Rolling Credits Effect inside Document */}
        <g clipPath="url(#docClip)">
          <motion.image
            href="/docmock.png"
            x="55"
            y={55 + (creditsOffset % 400)}
            width="190"
            height="400"
            preserveAspectRatio="xMidYMin slice"
            opacity="0.85"
          />
          {/* Duplicate for seamless loop */}
          <motion.image
            href="/docmock.png"
            x="55"
            y={55 + (creditsOffset % 400) + 400}
            width="190"
            height="400"
            preserveAspectRatio="xMidYMin slice"
            opacity="0.85"
          />
        </g>

        {/* Subtle glow effect */}
        <motion.rect
          x="48"
          y="48"
          width="204"
          height="264"
          rx="10"
          fill="none"
          stroke="#4040FF"
          strokeWidth="1"
          strokeOpacity="0.3"
          animate={{
            strokeOpacity: [0.1, 0.4, 0.1]
          }}
          transition={{
            duration: 3,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </svg>
    </div>
  );
}; 